module.exports = __webpack_public_path__ + "img/logo-tds-orange.6e218c9a.svg";